import { render, staticRenderFns } from "./PremiumPlansPage.vue?vue&type=template&id=9012dde4&scoped=true&"
import script from "./PremiumPlansPage.vue?vue&type=script&lang=ts&"
export * from "./PremiumPlansPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9012dde4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardSubtitle})
